export default __webpack_public_path__ + "static/media/table.1c0c7129.png";